import * as actionTypes from 'constants/ActionTypes';

export function createFilterAnnotations(data) {
    return {
        type: actionTypes.CREATE_FILTER_ANNOTATIONS_PREFERENCE.REQUEST,
        data,
    };
}



// WEBPACK FOOTER //
// ./app/actions/preferences/filterAnnotations.js